import { Flex } from 'theme-ui'

const Holding = ({ locale }: { locale: string }) => {
  function getHoldingText() {
    if (locale === 'en') {
      return 'This competition has now closed.'
    } else if (locale === 'fr') {
      return 'Ce concours est maintenant terminé.'
    } else if (locale === 'de') {
      return 'Dieser Wettbewerb ist jetzt geschlossen.'
    } else if (locale === 'se') {
      return 'Tävlingen har nu avslutats.'
    }
    return 'This competition has now closed.'
  }

  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '100dvw',
        height: '100dvh',
        textShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
        fontSize: '32px',
        fontWeight: 700,
        color: 'white',
        background:
          'url(/static/images/byds/backdrop.jpg) no-repeat center center',
      }}
    >
      <span style={{ textAlign: 'center', maxWidth: '80%', zIndex: 1 }}>
        {getHoldingText()}
      </span>
    </Flex>
  )
}

export default Holding
